document.addEventListener('DOMContentLoaded', ()=> {
    const swiper = new Swiper('.collection__subcollection', {
        // loop: true,
        spaceBetween: 32,
        slidesPerView: 'auto',
        breakpoints: {
            1280: {
                slidesPerView: 8
            },
            768:{
                slidesPerView: 5
            },
            300:{
                slidesPerView: 2,
                pagination:{
                     el: ".swiper-pagination",
                }
            }
        },

        pagination: {
            el: '.swiper-pagination',
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },


        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });

})
